var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{staticClass:"py-8"},[(!_vm.coupon)?_c('div',{staticClass:"text-center"},[_c('v-progress-circular',{staticClass:"text-center mx-auto my-8",attrs:{"indeterminate":""}})],1):_c('CouponForm',{attrs:{"coupon":_vm.coupon}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }